module.exports = __webpack_public_path__ + "img/parking.68226efe.png";